import { useEffect, useRef, useState } from 'react'

import { ICurrency } from '../../../store/fetchers/currencies'
import { useAppDispatch, useAppSelector } from '../../../store/hooks'
import { getCurrencies, fetchCurrencies } from '../../../store/reducers/currencies'

import styles from './styles.module.scss'
import ExchangePair from './exchange-pair'
import { useKeenSlider } from 'keen-slider/react'
import "keen-slider/keen-slider.min.css"

import cn from 'classnames'
import keenConfig from 'configs/keen-slider'

export interface ICurrencyPair {
  currencyFrom: ICurrency
  currencyTo: ICurrency
}

export function ExchangePairs({ toCurrency }) {
  const dispatch = useAppDispatch()

  const [availableCurrencies, setAvailableCurrencies] = useState<ICurrency[]>([])

  const currencies = useAppSelector(getCurrencies)
  const [topPairs, setTopPairs] = useState<ICurrencyPair[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const loaded = useRef(null)

  useEffect(() => {
    if (currencies.length) {
      setAvailableCurrencies(currencies.filter((c) => c.is_allowed_for_wallet))
    }
  }, [currencies])

  useEffect(() => {
    if (availableCurrencies.length && !loaded.current) {
      constructPairs()
      loaded.current = true
    }
  }, [availableCurrencies])

  useEffect(() => {
    if (topPairs.length) {
      setIsLoading(false)
    }
  }, [topPairs])

  const constructPairs = () => {
    const topPairs: ICurrencyPair[] = []
    for (const item of availableCurrencies) {
      if (
        item.code.toLowerCase() === toCurrency.ticker.toLowerCase() &&
        item.network.toLowerCase() === toCurrency.network.toLowerCase()
      ) {
        continue
      }
      const currencyPair: ICurrencyPair = {
        currencyFrom: item,
        currencyTo: availableCurrencies.find(
          (currency) =>
            currency.code.toLowerCase() === toCurrency.ticker.toLowerCase() &&
            currency.network.toLowerCase() === toCurrency.network.toLowerCase(),
        ),
      }
      if (currencyPair.currencyFrom && currencyPair.currencyTo) {
        topPairs.push(currencyPair)
      }
    }
    setTopPairs(topPairs)
  }

  useEffect(() => {
    dispatch(fetchCurrencies())
  }, [dispatch])

  const [slider1Ref] = useKeenSlider<HTMLDivElement>(keenConfig(32, true, 'right'), [])
  const [slider2Ref] = useKeenSlider<HTMLDivElement>(keenConfig(32, true, 'left'), [])
  const [slider3Ref] = useKeenSlider<HTMLDivElement>(keenConfig(32, true, 'right'), [])

  return (
    <section className={styles.cryptoAssets}>
      <div className={styles.cryptoAssets__main}>
        {isLoading && <>
          <div ref={slider1Ref} className={`keen-slider ${styles.cryptoAssets__main__row}`}>
            {Array(12).fill(0).map((_, idx) => (
              <div key={idx} className={cn('keen-slider__slide', styles.slide)}>
                <ExchangePair isLoading={true} />
              </div>
            ))}
          </div>

          <div ref={slider2Ref} className={`keen-slider ${styles.cryptoAssets__main__row}`}>
            {Array(12).fill(0).map((_, idx) => (
              <div key={idx} className={cn('keen-slider__slide', styles.slide)}>
                <ExchangePair isLoading={true} />
              </div>
            ))}
          </div>

          <div ref={slider3Ref} className={`keen-slider ${styles.cryptoAssets__main__row}`}>
            {Array(12).fill(0).map((_, idx) => (
              <div key={idx} className={cn('keen-slider__slide', styles.slide)}>
                <ExchangePair isLoading={true} />
              </div>
            ))}
          </div>
        </>}

        {!isLoading && <>
          <div ref={slider1Ref} className={`keen-slider ${styles.cryptoAssets__main__row}`}>
            {(topPairs.slice(0, topPairs.length / 3)).map((pair, idx) => (
              <div key={idx} className={cn('keen-slider__slide', styles.slide)}>
                <ExchangePair currencyPair={pair} isLoading={!pair} />
              </div>
            ))}
          </div>

          <div ref={slider2Ref} className={`keen-slider ${styles.cryptoAssets__main__row}`}>
            {(topPairs.slice(topPairs.length / 3, (topPairs.length / 3) * 2)).map((pair, idx) => (
              <div key={idx} className={cn('keen-slider__slide', styles.slide)}>
                <ExchangePair currencyPair={pair} isLoading={!pair} />
              </div>
            ))}
          </div>

          <div ref={slider3Ref} className={`keen-slider ${styles.cryptoAssets__main__row}`}>
            {(topPairs.slice((topPairs.length / 3) * 2)).map((pair, idx) => (
              <div key={idx} className={cn('keen-slider__slide', styles.slide)}>
                <ExchangePair currencyPair={pair} isLoading={!pair} />
              </div>
            ))}
          </div>
        </>}
      </div>
    </section>
  )
}
